import {Box, Stack} from '@mui/material';
import ResponsiveTypography from '../../ui/responsive-typography';
import {useTranslation} from 'react-i18next';
import PaymentMethodLogo from './payment-method-logo';
import visaLogo from '@/assets/images/payments/visa.png';
import amexLogo from '@/assets/images/payments/amex.png';
import mastercardLogo from '@/assets/images/payments/mastercard.png';
import googlepayLogo from '@/assets/images/payments/google-pay.png';
import applepayLogo from '@/assets/images/payments/apple-pay.svg';
import klarnaLogo from '@/assets/images/payments/klarna.png';

const PAYMENT_METHOD_SOURCES = [
  {
    src: visaLogo,
    alt: 'Visa'
  },
  {
    src: mastercardLogo,
    alt: 'MasterCard'
  },
  {
    src: amexLogo,
    alt: 'American Express'
  },
  {
    src: applepayLogo,
    alt: 'Apple Pay'
  },
  {
    src: googlepayLogo,
    alt: 'Google Pay'
  },
  {
    src: klarnaLogo,
    alt: 'Klarna'
  }
];

const PaymentMethods: React.FC = () => {
  const {t} = useTranslation();
  return (
    <Box sx={{marginTop: 4}}>
      <ResponsiveTypography mediumSmall>
        {t('supported_payment_methods')}
      </ResponsiveTypography>
      <Stack
        direction="row"
        spacing={2}
        rowGap={2}
        flexWrap={'wrap'}
        alignItems="center"
        sx={{marginTop: 1}}
      >
        {PAYMENT_METHOD_SOURCES.map((logo) => (
          <PaymentMethodLogo key={logo.alt} src={logo.src} alt={logo.alt} />
        ))}
      </Stack>
    </Box>
  );
};

export default PaymentMethods;
